<template>
<section :style="{ backgroundColor: backgroundColor }">
    <div class="px-4 py-10 mx-auto max-w-screen-2xl md:py-20 lg:px-8 xl:px-2 2xl:px-12">
       <div class="flex flex-wrap items-center justify-center 2xl:gap-x-16 xl:gap-x-12 gap-y-4 2xl:px-0 xl:px-0">
        <div class="md:w-64 xl:w-48 2xl:w-auto w-44">
            <nuxt-img class="mx-auto" :src="logo1Src" width="202" height="40" :alt="logo1Alt" loading="lazy" format="webp" />
        </div>

        <div class="md:w-64 lg:w-48 xl:w-52 2xl:w-auto w-44">
            <nuxt-img class="mx-auto" :src="logo2Src" width="227" height="83" :alt="logo2Alt" loading="lazy" format="webp" />
        </div>

        <div class="md:w-64 lg:w-48 xl:w-52 2xl:w-auto w-44">
            <nuxt-img class="mx-auto" :src="logo3Src" width="232" height="158" :alt="logo3Alt" loading="lazy" format="webp" />
        </div>

        <div class="md:w-64 lg:w-48 xl:w-52 2xl:w-auto w-44">
            <nuxt-img class="mx-auto" :src="logo4Src" width="131" height="50" :alt="logo4Alt" loading="lazy" format="webp" />
        </div>

        <div class="md:w-64 lg:w-48 xl:w-52 2xl:w-auto w-44">
            <nuxt-img class="mx-auto" :src="logo5Src" width="272" height="40" :alt="logo5Alt" loading="lazy" format="webp" />
        </div>
       </div>
    </div>
</section>
</template>

<script setup>
const props = defineProps({
    backgroundColor: {
        type: String,
        default: '#F7F6F9'
    },
    // Logo 1
    logo1Src: {
        type: String,
        default: '/assets/images/flex-logo-1.png'
    },
    logo1Alt: {
        type: String,
        default: 'logo'
    },
    // Logo 2
    logo2Src: {
        type: String,
        default: '/assets/images/flex-logo-2.png'
    },
    logo2Alt: {
        type: String,
        default: 'logo'
    },
    // Logo 3
    logo3Src: {
        type: String,
        default: '/assets/images/flex-logo-3.png'
    },
    logo3Alt: {
        type: String,
        default: 'logo'
    },
    // Logo 4
    logo4Src: {
        type: String,
        default: '/assets/images/flex-logo-4.png'
    },
    logo4Alt: {
        type: String,
        default: 'logo'
    },
    // Logo 5
    logo5Src: {
        type: String,
        default: '/assets/images/flex-logo-5.png'
    },
    logo5Alt: {
        type: String,
        default: 'logo'
    }
});

defineBuilderComponent({
    friendlyName: 'ListFlex Logos',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'color',
            friendlyName: 'Background Color',
            defaultValue: '#F7F6F9'
        },
        // Logo 1
        {
            name: 'logo1Src',
            type: 'file',
            friendlyName: 'Logo 1 Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
            defaultValue: '/assets/images/flex-logo-1.png'
        },
        {
            name: 'logo1Alt',
            type: 'text',
            friendlyName: 'Logo 1 Alt Text',
            defaultValue: 'logo'
        },
        // Logo 2
        {
            name: 'logo2Src',
            type: 'file',
            friendlyName: 'Logo 2 Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
            defaultValue: '/assets/images/flex-logo-2.png'
        },
        {
            name: 'logo2Alt',
            type: 'text',
            friendlyName: 'Logo 2 Alt Text',
            defaultValue: 'logo'
        },
        // Logo 3
        {
            name: 'logo3Src',
            type: 'file',
            friendlyName: 'Logo 3 Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
            defaultValue: '/assets/images/flex-logo-3.png'
        },
        {
            name: 'logo3Alt',
            type: 'text',
            friendlyName: 'Logo 3 Alt Text',
            defaultValue: 'logo'
        },
        // Logo 4
        {
            name: 'logo4Src',
            type: 'file',
            friendlyName: 'Logo 4 Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
            defaultValue: '/assets/images/flex-logo-4.png'
        },
        {
            name: 'logo4Alt',
            type: 'text',
            friendlyName: 'Logo 4 Alt Text',
            defaultValue: 'logo'
        },
        // Logo 5
        {
            name: 'logo5Src',
            type: 'file',
            friendlyName: 'Logo 5 Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
            defaultValue: '/assets/images/flex-logo-5.png'
        },
        {
            name: 'logo5Alt',
            type: 'text',
            friendlyName: 'Logo 5 Alt Text',
            defaultValue: 'logo'
        }
    ]
});
</script>